document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.Tally !== 'undefined' && typeof window.Tally.loadEmbeds === 'function') {
    window.Tally.loadEmbeds();
  } else {
    document.querySelectorAll('iframe[data-tally-src]:not([src])').forEach((iframeEl) => {
      iframeEl.src = iframeEl.dataset.tallySrc;
    });
  }

  const modal = document.querySelector('.free-design__success-modal');
  if (!modal) return;

  const closeButton = modal.querySelector('.free-design__success-close');

  const closeModal = () => {
    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');
  };

  const openModal = () => {
    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
  };

  closeButton?.addEventListener('click', closeModal);

  modal.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal();
  });

  window.addEventListener('message', (event) => {
    if (typeof event.data === 'string') {
      if (!event.data.includes('Tally.FormSubmitted')) return;

      try {
        JSON.parse(event.data);
        openModal();
      } catch (error) {
        console.error('Failed to parse Tally submission event', error);
      }

      return;
    }

    if (event.data?.event === 'Tally.FormSubmitted') {
      openModal();
    }
  });
});
